import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, withCtx as _withCtx, vModelRadio as _vModelRadio, renderList as _renderList, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 umt-card-header-tight" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fst-italic" }, "Mỗi dòng là một lần gửi Email/SMS/Zalo tới nhóm thí sinh — bấm vào dòng để xem chi tiết người nhận.")
], -1)
const _hoisted_5 = { class: "card-toolbar filter-slim d-flex align-items-center gap-3" }
const _hoisted_6 = { class: "d-flex align-items-center position-relative" }
const _hoisted_7 = { class: "svg-icon svg-icon-3 position-absolute ms-4" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end align-items-center",
  "data-kt-customer-table-toolbar": "selected"
}
const _hoisted_9 = { class: "fw-bolder me-5" }
const _hoisted_10 = { class: "me-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary me-3 btn-sm"
}, " Gửi mail các hồ sơ (đã chọn) ", -1)
const _hoisted_12 = { class: "svg-icon svg-icon-2" }
const _hoisted_13 = {
  type: "button",
  class: "btn btn-primary me-3 d-none btn-sm",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_option_add",
  ref: "kt_modal_option_add"
}
const _hoisted_14 = { class: "svg-icon svg-icon-2" }
const _hoisted_15 = { class: "card-body pt-0" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "menu-link text-gray-600" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "text-center menu-link text-gray-600" }
const _hoisted_20 = ["href"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Email", -1)
const _hoisted_23 = { class: "umt-stat-num" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "SMS", -1)
const _hoisted_26 = { class: "umt-stat-num" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Zalo", -1)
const _hoisted_29 = { class: "umt-stat-num" }
const _hoisted_30 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "menu-link text-gray-600" }
const _hoisted_33 = { class: "d-flex flex-center flex-wrap gap-1" }
const _hoisted_34 = {
  key: 0,
  class: "badge badge-light-info fs-8"
}
const _hoisted_35 = {
  key: 1,
  class: "badge badge-light-success fs-8"
}
const _hoisted_36 = {
  key: 2,
  class: "badge badge-light-primary fs-8"
}
const _hoisted_37 = {
  key: 3,
  class: "text-muted"
}
const _hoisted_38 = { class: "umt-stat" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Email", -1)
const _hoisted_41 = { class: "umt-stat-num text-success" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "SMS", -1)
const _hoisted_44 = { class: "umt-stat-num text-success" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Zalo", -1)
const _hoisted_47 = { class: "umt-stat-num text-success" }
const _hoisted_48 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_49 = {
  key: 0,
  class: "umt-stat"
}
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Email", -1)
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "umt-stat-num text-gray-500"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "SMS", -1)
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 1,
  class: "umt-stat-num text-gray-500"
}
const _hoisted_58 = { key: 2 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "umt-stat-ch" }, "Zalo", -1)
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 1,
  class: "umt-stat-num text-gray-500"
}
const _hoisted_62 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_63 = { class: "umt-stat" }
const _hoisted_64 = {
  key: 0,
  class: "umt-stat-num"
}
const _hoisted_65 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_66 = ["id"]
const _hoisted_67 = { class: "d-flex flex-center text-status" }
const _hoisted_68 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_69 = {
  key: 1,
  class: "badge badge-light text-gray-600"
}
const _hoisted_70 = { class: "progress h-6px w-100" }
const _hoisted_71 = ["href"]
const _hoisted_72 = { class: "menu-link text-gray-600" }
const _hoisted_73 = { class: "d-flex flex-center gap-3" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = { class: "svg-icon svg-icon-2 svg-icon-info" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "svg-icon svg-icon-2 svg-icon-primary" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = {
  class: "svg-icon svg-icon-2",
  style: {"opacity":"0.7"}
}
const _hoisted_80 = ["title", "onClick"]
const _hoisted_81 = {
  class: "svg-icon svg-icon-2 svg-icon-danger",
  style: {"opacity":"0.7"}
}
const _hoisted_82 = { class: "menu-link" }
const _hoisted_83 = {
  class: "svg-icon svg-icon-2 svg-icon-primary cursor-pointer",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end",
  title: "test mẫu gửi mail chiến dịch"
}
const _hoisted_84 = {
  class: "menu menu-sub menu-sub-dropdown w-350px w-md-350px",
  "data-kt-menu": "true"
}
const _hoisted_85 = {
  class: "modal fade",
  id: "kt_modal_option_add",
  ref: "addExporResultModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_86 = { class: "modal-dialog modal-dialog-centered mw-800px" }
const _hoisted_87 = { class: "modal-content" }
const _hoisted_88 = {
  class: "modal-header py-4 px-6",
  id: "kt_modal_add_customer_header"
}
const _hoisted_89 = { class: "fw-bolder fs-4 mb-0" }
const _hoisted_90 = {
  id: "kt_modal_add_customer_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_91 = { class: "svg-icon svg-icon-1" }
const _hoisted_92 = { class: "modal-body umt-form py-5 px-6" }
const _hoisted_93 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-800 mb-3" }, "Người nhận", -1)
const _hoisted_95 = { class: "mb-3" }
const _hoisted_96 = { class: "form-check form-check-solid" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ps-2",
  for: "optionStudent"
}, "Thí sinh trên hệ thống", -1)
const _hoisted_98 = { class: "form-check form-check-solid" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label ps-2",
  for: "optionStudent2"
}, "Import tập tin", -1)
const _hoisted_100 = {
  key: 0,
  class: ""
}
const _hoisted_101 = { class: "mb-2" }
const _hoisted_102 = {
  id: "id_dropzone",
  class: "dropzone w-100 text-center umt-dropzone-lg"
}
const _hoisted_103 = ["value"]
const _hoisted_104 = ["value"]
const _hoisted_105 = ["value"]
const _hoisted_106 = ["value"]
const _hoisted_107 = ["value"]
const _hoisted_108 = ["value"]
const _hoisted_109 = /*#__PURE__*/_createElementVNode("input", {
  class: "d-none",
  type: "text",
  name: "campaignType",
  value: "MARKETING"
}, null, -1)
const _hoisted_110 = /*#__PURE__*/_createElementVNode("input", {
  class: "d-none",
  type: "text",
  name: "peopleTarget",
  value: "custom"
}, null, -1)
const _hoisted_111 = ["value"]
const _hoisted_112 = {
  key: 0,
  class: "fs-8 text-muted"
}
const _hoisted_113 = ["href"]
const _hoisted_114 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_115 = {
  key: 0,
  class: "fs-8 text-danger"
}
const _hoisted_116 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon-fill me-1" }, null, -1)
const _hoisted_117 = {
  key: 1,
  class: "d-flex align-items-center flex-wrap gap-2 fs-8"
}
const _hoisted_118 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill text-success" }, null, -1)
const _hoisted_119 = { class: "text-gray-700" }
const _hoisted_120 = { class: "fw-bolder text-gray-900" }
const _hoisted_121 = { class: "text-muted" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "·", -1)
const _hoisted_123 = {
  key: 0,
  class: "text-warning w-100"
}
const _hoisted_124 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-triangle-fill me-1" }, null, -1)
const _hoisted_125 = { key: 0 }
const _hoisted_126 = { key: 1 }
const _hoisted_127 = { key: 2 }
const _hoisted_128 = {
  key: 1,
  class: "d-flex align-items-center gap-3 border border-gray-300 border-dashed rounded p-3"
}
const _hoisted_129 = ["src"]
const _hoisted_130 = { class: "fw-semibold text-gray-800" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("div", { class: "text-muted fs-8" }, "Danh sách đã import của chiến dịch này", -1)
const _hoisted_132 = {
  key: 0,
  class: "row g-3 mb-4"
}
const _hoisted_133 = { class: "col-12 col-lg-4" }
const _hoisted_134 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Nhóm thí sinh", -1)
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Đợt", -1)
const _hoisted_136 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder" }, "Phương thức xét tuyển", -1)
const _hoisted_137 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_138 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-800 mb-3" }, [
  /*#__PURE__*/_createTextVNode("Tên chiến dịch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted fs-8 fw-normal" }, "(nội bộ)")
], -1)
const _hoisted_139 = { class: "border border-gray-300 border-dashed rounded p-4 mb-4" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-6 text-gray-800 mb-3" }, "Kênh gửi & nội dung", -1)
const _hoisted_141 = { class: "d-flex flex-wrap gap-2 mb-4" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_143 = /*#__PURE__*/_createElementVNode("span", null, "Email", -1)
const _hoisted_144 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-left-text" }, null, -1)
const _hoisted_145 = /*#__PURE__*/_createElementVNode("span", null, "SMS", -1)
const _hoisted_146 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-chat-dots" }, null, -1)
const _hoisted_147 = /*#__PURE__*/_createElementVNode("span", null, "Zalo", -1)
const _hoisted_148 = {
  key: 0,
  class: "fv-row col-lg-7 mb-2"
}
const _hoisted_149 = { class: "d-flex align-items-center justify-content-between mb-1" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required mb-0" }, "Mẫu email", -1)
const _hoisted_151 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye me-1 text-primary" }, null, -1)
const _hoisted_152 = {
  key: 1,
  class: "d-flex mb-3"
}
const _hoisted_153 = { class: "fv-row col-12" }
const _hoisted_154 = { class: "form-label d-flex flex-stack" }
const _hoisted_155 = { class: "required fw-bolder" }
const _hoisted_156 = { class: "text-muted fw-normal fs-8" }
const _hoisted_157 = {
  key: 2,
  class: "d-flex gap-5 mb-3"
}
const _hoisted_158 = { class: "mb-3 fv-row col-lg-4" }
const _hoisted_159 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder required" }, "Chọn mẫu zalo gửi", -1)
const _hoisted_160 = {
  key: 0,
  class: "mb-3 p-3 border border-dashed border-warning card-rounded fv-row col-lg-8 bg-light-warning"
}
const _hoisted_161 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_162 = ["href"]
const _hoisted_163 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-4" }, null, -1)
const _hoisted_164 = /*#__PURE__*/_createElementVNode("div", { class: "mb-3 fs-8 text-gray-600" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-warning me-1" }),
  /*#__PURE__*/_createTextVNode(" Lưu xong chiến dịch "),
  /*#__PURE__*/_createElementVNode("b", { class: "text-gray-800" }, "chưa gửi ngay"),
  /*#__PURE__*/_createTextVNode(" — bấm nút chạy ở danh sách mới bắt đầu gửi. ")
], -1)
const _hoisted_165 = { class: "d-flex justify-content-end gap-3" }
const _hoisted_166 = /*#__PURE__*/_createElementVNode("span", {
  class: "btn btn-light umt-btn-32",
  "data-bs-dismiss": "modal"
}, "Hủy", -1)
const _hoisted_167 = {
  key: 0,
  class: "btn btn-primary umt-btn-32",
  type: "submit"
}
const _hoisted_168 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }, null, -1)
const _hoisted_169 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check2 me-1" }, null, -1)
const _hoisted_170 = { class: "ck-custom" }
const _hoisted_171 = { class: "d-flex align-items-center flex-wrap gap-3 mb-3" }
const _hoisted_172 = { class: "flex-grow-1 fs-8 text-muted" }
const _hoisted_173 = { class: "fw-bolder text-gray-800" }
const _hoisted_174 = { class: "fw-bolder text-danger" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download me-1" }, null, -1)
const _hoisted_176 = { style: {"max-height":"55vh","overflow":"auto"} }
const _hoisted_177 = { class: "table table-row-dashed align-middle fs-8 mb-0" }
const _hoisted_178 = { class: "text-muted" }
const _hoisted_179 = /*#__PURE__*/_createElementVNode("th", {
  class: "p-2",
  style: {"width":"40px"}
}, "#", -1)
const _hoisted_180 = /*#__PURE__*/_createElementVNode("th", {
  class: "p-2",
  style: {"min-width":"150px"}
}, "Họ và tên", -1)
const _hoisted_181 = {
  class: "p-2",
  style: {"min-width":"200px"}
}
const _hoisted_182 = /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Lý do", -1)
const _hoisted_183 = { class: "p-2 text-muted" }
const _hoisted_184 = { class: "p-2 fw-semibold text-gray-800" }
const _hoisted_185 = { class: "p-2 text-break" }
const _hoisted_186 = {
  class: "p-2 text-gray-600 text-break",
  style: {"word-break":"break-word"}
}
const _hoisted_187 = {
  key: 0,
  class: "fs-8 text-muted mb-2"
}
const _hoisted_188 = { class: "fw-bolder text-gray-800" }
const _hoisted_189 = { key: 0 }
const _hoisted_190 = { style: {"max-height":"55vh","overflow":"auto"} }
const _hoisted_191 = { class: "table table-row-dashed align-middle fs-8 mb-0" }
const _hoisted_192 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Họ và tên"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Điện thoại"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Mã hồ sơ"),
    /*#__PURE__*/_createElementVNode("th", { class: "p-2" }, "Ngành học")
  ])
], -1)
const _hoisted_193 = { class: "p-2 text-muted" }
const _hoisted_194 = { class: "p-2 fw-semibold text-gray-800" }
const _hoisted_195 = { class: "p-2" }
const _hoisted_196 = { class: "p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_testMail = _resolveComponent("testMail")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModalViewTemplateMail = _resolveComponent("ModalViewTemplateMail")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  class: "form-control w-250px ps-11",
                  placeholder: "Tìm tên chiến dịch...",
                  style: {"height":"32px","min-height":"32px","padding-top":"0","padding-bottom":"0","font-size":"13px"}
                }, null, 512), [
                  [_vModelText, _ctx.search]
                ])
              ]),
              (_ctx.checkedCustomers.length != 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.checkedCustomers.length), 1),
                      _createTextVNode("Đã chọn ")
                    ]),
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-sm",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)))
              }, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                ]),
                _createTextVNode(" Thêm chiến dịch ")
              ]),
              _createElementVNode("button", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen035.svg" })
                ])
              ], 512)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Datatable, {
              "table-data": _ctx.tableData,
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": true,
              onCurrentCheckAll: _ctx.checkAll,
              isCheck: _ctx.checkDefault,
              loading: _ctx.loading,
              "class-table": "umt-table-tight",
              emptyTableText: "Chưa có chiến dịch nào — bấm “Thêm chiến dịch” để tạo lần gửi đầu tiên."
            }, {
              "cell-createdAt": _withCtx(({ row: customer }) => [
                _createElementVNode("a", {
                  href: `/chiendichmailmarketing/${customer.id}`,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(customer.createdAtFormat), 1)
                ], 8, _hoisted_16)
              ]),
              "cell-phaseTarget": _withCtx(({ row: customer }) => [
                _createElementVNode("a", {
                  href: `/chiendichmailmarketing/${customer.id}`,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(customer.phaseTarget =="0"?'Tất cả':customer.phaseTarget), 1)
                ], 8, _hoisted_18)
              ]),
              "cell-emailTotal": _withCtx(({ row: customer }) => [
                _createElementVNode("a", {
                  href: `/chiendichmailmarketing/${customer.id}`,
                  target: "_blank",
                  class: "d-block umt-stat"
                }, [
                  (customer.mailChecked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("span", _hoisted_23, _toDisplayString(customer.emailTotal || 0), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (customer.smsChecked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("span", _hoisted_26, _toDisplayString(customer.smsTotal || 0), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (customer.zaloChecked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                        _hoisted_28,
                        _createElementVNode("span", _hoisted_29, _toDisplayString(customer.zaloTotal || 0), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!customer.mailChecked && !customer.smsChecked && !customer.zaloChecked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, "—"))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_20)
              ]),
              "cell-name": _withCtx(({ row: customer }) => [
                _createElementVNode("a", {
                  href: `/chiendichmailmarketing/${customer.id}`,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_32, _toDisplayString(customer.name), 1)
                ], 8, _hoisted_31)
              ]),
              "cell-channels": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_33, [
                  (customer.mailChecked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Email"))
                    : _createCommentVNode("", true),
                  (customer.smsChecked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, "SMS"))
                    : _createCommentVNode("", true),
                  (customer.zaloChecked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, "Zalo"))
                    : _createCommentVNode("", true),
                  (!customer.mailChecked && !customer.smsChecked && !customer.zaloChecked)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "—"))
                    : _createCommentVNode("", true)
                ])
              ]),
              "cell-sentEmailTotal": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_38, [
                  (customer.status != 'none')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (customer.mailChecked)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _hoisted_40,
                              _createElementVNode("span", _hoisted_41, _toDisplayString(customer.sentEmailTotal || 0), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (customer.smsChecked)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                              _hoisted_43,
                              _createElementVNode("span", _hoisted_44, _toDisplayString(customer.sentSmsTotal || 0), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (customer.zaloChecked)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _hoisted_46,
                              _createElementVNode("span", _hoisted_47, _toDisplayString(customer.sentZaloTotal || 0), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock("span", _hoisted_48, "—"))
                ])
              ]),
              "cell-failedEmailTotal": _withCtx(({ row: customer }) => [
                (customer.status != 'none')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      (customer.mailChecked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _hoisted_51,
                            (customer.failedEmailTotal)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "umt-stat-num text-danger umt-stat-link",
                                  onClick: ($event: any) => (_ctx.openFailedItems(customer, 'email')),
                                  title: "Xem danh sách gửi lỗi"
                                }, _toDisplayString(customer.failedEmailTotal), 9, _hoisted_52))
                              : (_openBlock(), _createElementBlock("span", _hoisted_53, "0"))
                          ]))
                        : _createCommentVNode("", true),
                      (customer.smsChecked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                            _hoisted_55,
                            (customer.failedSmsTotal)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "umt-stat-num text-danger umt-stat-link",
                                  onClick: ($event: any) => (_ctx.openFailedItems(customer, 'sms')),
                                  title: "Xem danh sách gửi lỗi"
                                }, _toDisplayString(customer.failedSmsTotal), 9, _hoisted_56))
                              : (_openBlock(), _createElementBlock("span", _hoisted_57, "0"))
                          ]))
                        : _createCommentVNode("", true),
                      (customer.zaloChecked)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _hoisted_59,
                            (customer.failedZaloTotal)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "umt-stat-num text-danger umt-stat-link",
                                  onClick: ($event: any) => (_ctx.openFailedItems(customer, 'zalo')),
                                  title: "Xem danh sách gửi lỗi"
                                }, _toDisplayString(customer.failedZaloTotal), 9, _hoisted_60))
                              : (_openBlock(), _createElementBlock("span", _hoisted_61, "0"))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_62, "—"))
              ]),
              "cell-openedTotal": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_63, [
                  (customer.status != 'none')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_64, _toDisplayString(customer.openedTotal || 0), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_65, "—"))
                ])
              ]),
              "cell-process": _withCtx(({ row: customer }) => [
                _createElementVNode("div", {
                  class: "d-flex flex-column w-100 me-2 custom-process-animation",
                  id: customer.id
                }, [
                  _createElementVNode("div", _hoisted_67, [
                    (customer.status != 'none')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_68, "Đã gửi"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_69, "Chưa gửi"))
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _createElementVNode("div", {
                      class: "progress-bar bg-primary",
                      role: "progressbar",
                      style: _normalizeStyle(`width:${customer.percent}%`),
                      "aria-valuenow": "50",
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }, null, 4)
                  ])
                ], 8, _hoisted_66)
              ]),
              "cell-groupTarget": _withCtx(({ row: customer }) => [
                _createElementVNode("a", {
                  href: `/chiendichmailmarketing/${customer.id}`,
                  target: "_blank"
                }, [
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("span", {
                      class: _normalizeClass(`m-auto badge badge-light-${
                      _ctx.arrTag[customer.peopleTarget]
                        ? _ctx.arrTag[customer.peopleTarget]?.state
                        : 'info'
                    }`)
                    }, _toDisplayString(_ctx.arrTag[customer.peopleTarget]
                        ? _ctx.arrTag[customer.peopleTarget].label
                        : customer.peopleTarget=='all'?'Tất cả':customer.peopleTarget), 3),
                    (customer.groupTarget)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" - " + _toDisplayString(customer.groupTarget=='all'?'Tất cả':customer.groupTarget), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ], 8, _hoisted_71)
              ]),
              "cell-actions": _withCtx(({ row: customer }) => [
                _createElementVNode("div", _hoisted_73, [
                  (customer.status != 'none')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "menu-link cursor-pointer",
                        onClick: ($event: any) => (_ctx.sendMail(customer)),
                        title: "Gửi lại"
                      }, [
                        _createElementVNode("span", _hoisted_75, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/customer/mail-replay.svg" })
                        ])
                      ], 8, _hoisted_74))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        class: "menu-link cursor-pointer",
                        onClick: ($event: any) => (_ctx.sendMail(customer)),
                        title: "Gửi mail"
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr027.svg" })
                        ])
                      ], 8, _hoisted_76)),
                  _createElementVNode("span", {
                    class: "menu-link cursor-pointer",
                    onClick: ($event: any) => (_ctx.editRow(customer)),
                    title: "Chỉnh sửa"
                  }, [
                    _createElementVNode("span", _hoisted_79, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen58.svg" })
                    ])
                  ], 8, _hoisted_78),
                  _createElementVNode("span", {
                    class: _normalizeClass(["menu-link", customer.status != 'none' ? 'umt-act-off' : 'cursor-pointer']),
                    title: customer.status != 'none' ? 'Chiến dịch đã gửi — không xoá được' : 'Xoá chiến dịch',
                    onClick: ($event: any) => (customer.status == 'none' && _ctx.deleteRow(customer))
                  }, [
                    _createElementVNode("span", _hoisted_81, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/customer/remove-file.svg" })
                    ])
                  ], 10, _hoisted_80),
                  _createElementVNode("span", _hoisted_82, [
                    _createElementVNode("span", _hoisted_83, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen015.svg" })
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _createVNode(_component_testMail, {
                        campaignId: customer.id,
                        type: "MARKETING"
                      }, null, 8, ["campaignId"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page", "onCurrentCheckAll", "isCheck", "loading"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_85, [
      _createElementVNode("div", _hoisted_86, [
        _createElementVNode("div", _hoisted_87, [
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("h2", _hoisted_89, _toDisplayString(_ctx.isEdit ? 'Chỉnh sửa chiến dịch' : 'Thêm chiến dịch'), 1),
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("span", _hoisted_91, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              model: _ctx.formData,
              rules: _ctx.rules,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _hoisted_94,
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["d-flex flex-wrap gap-3", _ctx.isEdit?'disabled':''])
                      }, [
                        _createElementVNode("div", _hoisted_96, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            value: "1",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.optionData.option) = $event)),
                            name: "optionStudent",
                            id: "optionStudent"
                          }, null, 512), [
                            [_vModelRadio, _ctx.optionData.option]
                          ]),
                          _hoisted_97
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            value: "2",
                            name: "optionStudent",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.optionData.option) = $event)),
                            id: "optionStudent2"
                          }, null, 512), [
                            [_vModelRadio, _ctx.optionData.option]
                          ]),
                          _hoisted_99
                        ])
                      ], 2)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["mb-4", _ctx.optionData.option == '2'?'':'d-none'])
                    }, [
                      (!_ctx.isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                            _createElementVNode("div", _hoisted_101, [
                              _createElementVNode("form", _hoisted_102, [
                                _createElementVNode("input", {
                                  class: "d-none",
                                  type: "text",
                                  name: "mailChecked",
                                  value: _ctx.optionData.type.includes('email')?'1':'0'
                                }, null, 8, _hoisted_103),
                                (_ctx.optionData.type.includes('email'))
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      class: "d-none",
                                      type: "text",
                                      name: "mailTemplateId",
                                      value: _ctx.formData.typeTemplate
                                    }, null, 8, _hoisted_104))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  class: "d-none",
                                  type: "text",
                                  name: "smsChecked",
                                  value: _ctx.optionData.type.includes('sms')?'1':'0'
                                }, null, 8, _hoisted_105),
                                (_ctx.optionData.type.includes('sms'))
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 1,
                                      class: "d-none",
                                      type: "text",
                                      name: "smsMessage",
                                      value: _ctx.formData.smsMessage
                                    }, null, 8, _hoisted_106))
                                  : _createCommentVNode("", true),
                                _createElementVNode("input", {
                                  class: "d-none",
                                  type: "text",
                                  name: "zaloChecked",
                                  value: _ctx.optionData.type.includes('zalo')?'1':'0'
                                }, null, 8, _hoisted_107),
                                (_ctx.optionData.type.includes('zalo'))
                                  ? (_openBlock(), _createElementBlock("input", {
                                      key: 2,
                                      class: "d-none",
                                      type: "text",
                                      name: "zaloTemplateId",
                                      value: _ctx.formData.zaloTemplateId
                                    }, null, 8, _hoisted_108))
                                  : _createCommentVNode("", true),
                                _hoisted_109,
                                _hoisted_110,
                                _createElementVNode("input", {
                                  class: "d-none",
                                  type: "text",
                                  name: "name",
                                  value: _ctx.formData.name
                                }, null, 8, _hoisted_111)
                              ])
                            ]),
                            (!_ctx.importPreview)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                                  _createTextVNode(" File .csv theo mẫu, mỗi dòng một thí sinh. "),
                                  _createElementVNode("a", {
                                    href: _ctx.sampleImportUrl,
                                    class: "text-primary fw-semibold text-hover-primary ms-1"
                                  }, "Tải file mẫu", 8, _hoisted_113)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.importPreview)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                                  (_ctx.importPreview.error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                        _hoisted_116,
                                        _createTextVNode(_toDisplayString(_ctx.importPreview.error), 1)
                                      ]))
                                    : (!_ctx.importPreview.loading)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                          _hoisted_118,
                                          _createElementVNode("span", _hoisted_119, [
                                            _createTextVNode("Đọc được "),
                                            _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.importPreview.total), 1),
                                            _createTextVNode(" người nhận từ file "),
                                            _createElementVNode("span", _hoisted_121, _toDisplayString(_ctx.importPreview.fileName), 1)
                                          ]),
                                          _createElementVNode("a", {
                                            class: "text-primary fw-semibold cursor-pointer",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.importPreviewVisible = true))
                                          }, "Xem danh sách"),
                                          _hoisted_122,
                                          _createElementVNode("a", {
                                            class: "text-muted cursor-pointer text-hover-primary",
                                            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clearImportFile && _ctx.clearImportFile(...args))),
                                            title: "Bỏ file đang chọn"
                                          }, "Bỏ file"),
                                          (_ctx.importPreview.noEmail || _ctx.importPreview.noPhone)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_123, [
                                                _hoisted_124,
                                                (_ctx.importPreview.noEmail)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_125, _toDisplayString(_ctx.importPreview.noEmail) + " dòng thiếu email", 1))
                                                  : _createCommentVNode("", true),
                                                (_ctx.importPreview.noEmail && _ctx.importPreview.noPhone)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_126, " · "))
                                                  : _createCommentVNode("", true),
                                                (_ctx.importPreview.noPhone)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(_ctx.importPreview.noPhone) + " dòng thiếu SĐT", 1))
                                                  : _createCommentVNode("", true),
                                                _createTextVNode(" — sẽ không gửi được kênh tương ứng ")
                                              ]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                            _createElementVNode("img", {
                              src: `/media/svg/files/excel.svg`,
                              alt: "",
                              style: {"width":"32px","height":"32px"}
                            }, null, 8, _hoisted_129),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_130, "import" + _toDisplayString(_ctx.formData.id) + ".csv", 1),
                              _hoisted_131
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 2),
                    (_ctx.optionData.option == '1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                          _createElementVNode("div", _hoisted_133, [
                            _hoisted_134,
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Thí sinh",
                                onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.peopleTargetChange())),
                                modelValue: _ctx.formData.peopleTarget,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.peopleTarget) = $event)),
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    label: "Tất cả (có hồ sơ)",
                                    value: "all_reg"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Tất cả (chưa có hồ sơ)",
                                    value: "all_noreg"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Thí sinh đã trúng tuyển",
                                    value: "all"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Trúng tuyển (đã đọc email)",
                                    value: "read"
                                  }),
                                  _createVNode(_component_el_option, {
                                    label: "Trúng tuyển (chưa đọc email)",
                                    value: "unread"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-6 col-lg-4", _ctx.formData.peopleTarget=='all_noreg'?'disabled':''])
                          }, [
                            _hoisted_135,
                            _createElementVNode("div", null, [
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Đợt",
                                modelValue: _ctx.formData.phase,
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.phase) = $event)),
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrPhase, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: item.name,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ])
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(["col-6 col-lg-4", _ctx.formData.peopleTarget=='all_noreg'?'disabled':''])
                          }, [
                            _hoisted_136,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid w-100",
                              placeholder: "Tất cả",
                              modelValue: _ctx.formData.method,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.method) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Tất cả",
                                  value: "all"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Học bạ",
                                  value: "HOCBA"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Đánh giá năng lực ĐHQG",
                                  value: "DGNL"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Tốt nghiệp THPT",
                                  value: "THPT"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Tuyển thẳng",
                                  value: "UMT"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ], 2)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_137, [
                    _hoisted_138,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "text",
                          name: "name",
                          modelValue: _ctx.formData.name,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.name) = $event)),
                          placeholder: "VD: Nhắc nhập học đợt 3 - tháng 8"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    _hoisted_140,
                    _createElementVNode("div", _hoisted_141, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["umt-ch-chip", { active: _ctx.optionData.type.includes('email') }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "email",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.optionData.type) = $event)),
                          name: "optionData",
                          id: "option"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.optionData.type]
                        ]),
                        _hoisted_142,
                        _hoisted_143
                      ], 2),
                      _createElementVNode("label", {
                        class: _normalizeClass(["umt-ch-chip", { active: _ctx.optionData.type.includes('sms') }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "sms",
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.optionData.type) = $event)),
                          name: "optionData",
                          id: "option1"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.optionData.type]
                        ]),
                        _hoisted_144,
                        _hoisted_145
                      ], 2),
                      _createElementVNode("label", {
                        class: _normalizeClass(["umt-ch-chip", { active: _ctx.optionData.type.includes('zalo') }])
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "checkbox",
                          value: "zalo",
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.optionData.type) = $event)),
                          name: "optionData",
                          id: "option2"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.optionData.type]
                        ]),
                        _hoisted_146,
                        _hoisted_147
                      ], 2)
                    ]),
                    (_ctx.optionData.type.includes('email'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                          _createElementVNode("div", _hoisted_149, [
                            _hoisted_150,
                            (_ctx.formData.typeTemplate)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "text-primary fw-semibold cursor-pointer fs-8",
                                  onClick: _cache[14] || (_cache[14] = e=>_ctx.viewMail())
                                }, [
                                  _hoisted_151,
                                  _createTextVNode("Xem trước ")
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_el_form_item, { prop: "typeTemplate" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                "popper-class": "umt-form-dd",
                                class: "form-select-solid w-100",
                                placeholder: "Chọn mẫu nội dung sẽ gửi cho thí sinh",
                                modelValue: _ctx.formData.typeTemplate,
                                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.typeTemplate) = $event)),
                                filterable: true
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mailtemplate, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.id,
                                      label: `${item.name}`,
                                      value: item.id
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.optionData.type.includes('sms'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_152, [
                          _createElementVNode("div", _hoisted_153, [
                            _createElementVNode("label", _hoisted_154, [
                              _createElementVNode("span", _hoisted_155, [
                                _createTextVNode("Nội dung SMS "),
                                _createElementVNode("span", _hoisted_156, "(" + _toDisplayString(_ctx.formData.smsMessage?.length || 0) + "/160 ký tự)", 1)
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", {
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.insertSomething('MA_HO_SO'))),
                                  class: "cursor-pointer badge badge-secondary fs-7 ms-2 me-2 mb-2"
                                }, "MA_HO_SO")
                              ])
                            ]),
                            _createVNode(_component_el_form_item, { prop: "smsMessage" }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("textarea", {
                                  class: "form-control form-control-solid border-0 p-4 resize-none",
                                  style: {"min-height":"110px"},
                                  rows: "4",
                                  placeholder: "Nội dung SMS",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.smsMessage) = $event)),
                                  max: "160",
                                  min: "0",
                                  name: "smsMessage",
                                  onKeyup: _cache[18] || (_cache[18] = ($event: any) => {_ctx.removeAccents($event.target);_ctx.checkLength($event);})
                                }, null, 544), [
                                  [_vModelText, _ctx.formData.smsMessage]
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.optionData.type.includes('zalo'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                          _createElementVNode("div", _hoisted_158, [
                            _hoisted_159,
                            _createVNode(_component_el_select, {
                              "popper-class": "umt-form-dd",
                              class: "form-select-solid",
                              placeholder: "Chọn mẫu zalo gửi",
                              modelValue: _ctx.formData.zaloTemplateId,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.zaloTemplateId) = $event)),
                              onChange: _ctx.getReviewZalo
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrZaloTemplateids, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.value,
                                    label: item.label,
                                    value: item.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          (_ctx.reviewZalo)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                _createTextVNode(" Mẫu template id: " + _toDisplayString(_ctx.reviewZalo.templateId) + " - " + _toDisplayString(_ctx.reviewZalo.templateName) + " ", 1),
                                _hoisted_161,
                                _createTextVNode(" Link review: "),
                                _createElementVNode("a", {
                                  href: _ctx.reviewZalo.previewUrl,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, _toDisplayString(_ctx.reviewZalo.previewUrl), 9, _hoisted_162)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_163,
                  _hoisted_164,
                  _createElementVNode("div", _hoisted_165, [
                    _hoisted_166,
                    (_ctx.optionData.option == '1' || _ctx.isEdit)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_167, [
                          _hoisted_168,
                          _createTextVNode("Lưu ")
                        ]))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "btn btn-primary umt-btn-32",
                          onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.startUpload && _ctx.startUpload(...args)))
                        }, [
                          _hoisted_169,
                          _createTextVNode("Lưu ")
                        ]))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ])
      ])
    ], 512),
    _createElementVNode("div", _hoisted_170, [
      _createVNode(_component_ModalViewTemplateMail, {
        ref: "viewTemplateMail",
        title: _ctx.titleMail,
        html: _ctx.editorData
      }, null, 8, ["title", "html"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.failedVisible,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.failedVisible) = $event)),
      title: `Danh sách gửi lỗi — ${_ctx.failedModal.channelLabel}`,
      width: "880px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", {
          class: "btn btn-light umt-btn-32",
          onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.failedVisible = false))
        }, "Đóng")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_171, [
          _createElementVNode("div", _hoisted_172, [
            _createTextVNode(" Chiến dịch "),
            _createElementVNode("span", _hoisted_173, _toDisplayString(_ctx.failedModal.campaignName || '—'), 1),
            _createTextVNode(" · "),
            _createElementVNode("span", _hoisted_174, _toDisplayString(_ctx.failedModal.items.length), 1),
            _createTextVNode(" trường hợp không gửi được. Sửa xong dữ liệu người nhận thì bấm nút chạy lại ở danh sách — hệ chỉ gửi cho các trường hợp thất bại. ")
          ]),
          _createElementVNode("span", {
            class: "btn btn-sm btn-light-success umt-btn-32",
            onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.exportFailedItems && _ctx.exportFailedItems(...args)))
          }, [
            _hoisted_175,
            _createTextVNode("Tải Excel ")
          ])
        ]),
        _createElementVNode("div", _hoisted_176, [
          _createElementVNode("table", _hoisted_177, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_178, [
                _hoisted_179,
                _hoisted_180,
                _createElementVNode("th", _hoisted_181, _toDisplayString(_ctx.failedModal.channel === 'email' ? 'Email' : 'Số điện thoại'), 1),
                _hoisted_182
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.failedModal.items, (r, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'fi' + i
                }, [
                  _createElementVNode("td", _hoisted_183, _toDisplayString(i + 1), 1),
                  _createElementVNode("td", _hoisted_184, _toDisplayString(r.fullName || '—'), 1),
                  _createElementVNode("td", _hoisted_185, _toDisplayString((_ctx.failedModal.channel === 'email' ? r.email : r.phone) || '—'), 1),
                  _createElementVNode("td", _hoisted_186, _toDisplayString(r.error || '—'), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.importPreviewVisible,
      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.importPreviewVisible) = $event)),
      title: "Danh sách người nhận trong file",
      width: "820px",
      "append-to-body": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", {
          class: "btn btn-light umt-btn-32",
          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.importPreviewVisible = false))
        }, "Đóng")
      ]),
      default: _withCtx(() => [
        (_ctx.importPreview)
          ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
              _createTextVNode(" Chiến dịch sẽ gửi tới "),
              _createElementVNode("span", _hoisted_188, _toDisplayString(_ctx.importPreview.total), 1),
              _createTextVNode(" người trong file " + _toDisplayString(_ctx.importPreview.fileName) + " ", 1),
              (_ctx.importPreview.total > 200)
                ? (_openBlock(), _createElementBlock("span", _hoisted_189, " — hiển thị 200 dòng đầu"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_190, [
          _createElementVNode("table", _hoisted_191, [
            _hoisted_192,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.importPreview ? _ctx.importPreview.rows.slice(0, 200) : []), (r, i) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: 'ip' + i
                }, [
                  _createElementVNode("td", _hoisted_193, _toDisplayString(i + 1), 1),
                  _createElementVNode("td", _hoisted_194, _toDisplayString(r.hovaten || '—'), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["p-2", r.email ? '' : 'text-danger fst-italic'])
                  }, _toDisplayString(r.email || 'thiếu email'), 3),
                  _createElementVNode("td", {
                    class: _normalizeClass(["p-2", r.dienthoai ? '' : 'text-muted fst-italic'])
                  }, _toDisplayString(r.dienthoai || '—'), 3),
                  _createElementVNode("td", _hoisted_195, _toDisplayString(r.mahoso || '—'), 1),
                  _createElementVNode("td", _hoisted_196, _toDisplayString(r.nganhhoc || '—'), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}